<template>
  <div class="d-flex flex-column">
    <div class="booking-container position-relative">
      <BookingBg class="booking-bg" />
      <div class="container--fluid h-100 position-relative d-flex justify-content-center flex-wrap mx-6">
        <VRow
          class="booking-container__top d-flex justify-content-center position-relative breakpoint-xl align-items-top flex-wrap"
          style="z-index: 1"
        >
          <VCol
            cols="12"
            lg="5"
            md="5"
            sm="12"
            xs="12"
            class="col-12 mt-24 offset-md-1 offset-lg-1"
          >
            <div
              v-if="homePageData"
              class="title-info"
            >
              <div class="heading-5 pre-title textPrimary--text mb-2">
                {{ homePageData.preTitle }}
              </div>
              <h1 class="heading-3 textPrimary--text">
                {{ homePageData.title }}
              </h1>
              <div class="subtitle-1 textPrimary--text">
                {{ homePageData.subTitle }}
              </div>
            </div>
          </VCol>
          <VCol
            cols="12"
            lg="4"
            md="6"
            sm="8"
            xs="12"
            class="d-flex justify-center col-12"
          >
            <BookingForm class="booking-form-container" />
          </VCol>
        </VRow>
      </div>
    </div>
    <div
      v-if="homePageData"
      class="h-100 position-relative d-flex justify-content-center flex-wrap mx-6 flex-column align-center"
    >
      <About
        v-if="homePageData.section1"
        :data="homePageData.section1"
        class="wrap mb-6 w-100"
      />
      <AdditionalInfo
        v-if="homePageData.section2"
        :data="homePageData.section2"
        class="wrap mb-6 w-100"
      />
      <AdditionalInfo
        v-if="homePageData.section3"
        :data="homePageData.section3"
        :threeColumns="true"
        class="wrap mb-6 w-100"
      />
      <TryOurApp
        v-if="homePageData.tryOurApp"
        :data="homePageData.tryOurApp"
        class="wrap mb-6 w-100 try-app"
      />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'BookingPage',
  metaInfo: {
    // override the parent template and just use the above title only
    titleTemplate: 'Booking',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { property: 'og:site_name', content: 'MILO booking app' },
    ],
  },
};
</script>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { SStrapiService } from '@slg/web-customer-shared';
import About from '@/components/strapi/About.vue';
import AdditionalInfo from '@/components/strapi/AdditionalInfo.vue';
import TryOurApp from '@/components/strapi/TryOurApp.vue';
import BookingForm from '@/components/bookingForm/BookingForm.vue';
import BookingBg from '@/components/bookingForm/BookingBg.vue';
import { useGtm, useCmsLocaleReload } from '@/composables';

const { trackGtmEvent } = useGtm();
const homePageData = ref<Record<string, any> | null>(null);

async function getHomePageData() {
  try {
    homePageData.value = await SStrapiService.getHomePage();
  } catch (error) {
    // to-do rethink about catch
  }
}

async function loadCmsData() {
  await getHomePageData();
}

useCmsLocaleReload(loadCmsData);

onMounted(() => {
  trackGtmEvent(
    'Booking page',
    'Page',
    'Loaded',
    'Booking page is loaded',
  );
});
</script>

<style lang="scss" scoped>
@import "@/style/variables.scss";

.booking-container {
  padding-top: 24px;
  padding-bottom: 31px;
  margin-bottom: 61px;
  min-height: 588px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position-x: center;

  .booking-container__top {
    .title-info {
      background: rgba(255, 255, 255, 0.82);
      border: 2px solid;
      border-image-source: linear-gradient(180deg, rgba(255, 255, 255, 0.16) 0%, rgba(96, 96, 96, 0.2) 100%);
      border-radius: 8px;
      padding: 24px;
    }

    .subtitle-1 {
      max-width: 320px;
    }
  }

  .booking-form-container {
    z-index: 1;
  }

  .breakpoint-xl {
    @media screen and (max-width: 960px) {
      max-width: 810px;
    }
  }
}

.wrap {
  max-width: 810px;
}

@media screen and (min-width: 1280px) {
  .offset-lg-2 {
    margin-right: 16.6666666667% !important;
    margin-left: unset !important;
  }

  .offset-lg-1 {
    margin-right: 16.333333% !important;
    margin-left: unset !important;
  }

  .booking-container__top {
    .title-info {
      margin-top: 95px;
    }
  }
}

@media screen and (min-width: 960px) {
  .booking-form-container {
    margin-bottom: auto;
  }
  .booking-container__top {
    .title-info {
      margin-top: 80px;
    }
  }
}

@media screen and (max-width: 600px) {
  .booking-container__top {
    .heading-3 {
      font-size: $fs-20;
    }

    .subtitle-1 {
      font-size: $fs-14;
    }
  }
}
</style>
